import * as Yup from "yup";
import moment from 'moment';

const isDate = (value) => {
  return moment(value, 'YYYY-MM-DD', true).isValid();
}

export const schema = Yup.object().shape({
  name: Yup.string().required("El nombre es requerido"),
  description: Yup.string(),
  showFieldComment: Yup.boolean(),
  messageComment: Yup.string().when('showFieldComment', {
    is: true,
    then: Yup.string().required("El mensaje es requerido"),
    otherwise: Yup.string().notRequired()
  }),
  isCommentAnswer: Yup.boolean(),
  triggerAnswer: Yup.string().optional(),
  isRequiredAnswer: Yup.boolean(),
  errorMessage: Yup.string().when('isRequiredAnswer', {
    is: true,
    then: Yup.string().required("El mensaje es requerido"),
    otherwise: Yup.string().notRequired()
  }),
  helperText: Yup.string(),
  requiredValidInput: Yup.boolean(),
  min: Yup.string().when(['requiredValidInput', 'questionType'], {
    is: (requiredValidInput, questionType) => requiredValidInput && ['Valor numérico', 'Fecha', 'Fecha y hora'].includes(questionType),
    then: Yup.string().when('max', (max, schema) =>{
      return schema.test({
        name: 'min',
        exclusive: true,
        message: 'El valor mínimo debe ser menor al valor máximo',
        test: function(min){
          return !min || !max || (isDate(min) ?  moment(min).isSameOrBefore(max) : parseFloat(min) < parseFloat(max));
        }
      })
    }),
    otherwise: Yup.string().notRequired()
  }),
  max: Yup.string().when('requiredValidInput', {
    is: true,
    then: Yup.string().required("El valor máximo es requerido"),
    otherwise: Yup.string().notRequired()
  }),
  validationError: Yup.string().when('requiredValidInput', {
    is: true,
    then: Yup.string().required("El mensaje es requerido"),
    otherwise: Yup.string().notRequired()
  }),
  questionType: Yup.string().required("El usuario es requerido"),
  score: Yup.number().optional()
});